<template>
  <div>
    <a @click="orderViewRouter(row.user_key, row.key)">
      <i class="material-icons">remove_red_eye</i>
    </a>
  </div>
</template>
<script>
export default {
  props: ["row", "nested"],
  methods: {
    // Order view
    orderViewRouter(userKey, orderKey) {
      let params = { userKey, orderKey };
      this.$router.push({ name: "OrderView", params });
    },
  },
};
</script>
<style scoped>
a {
  cursor: pointer;
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Operations/OrderOpt.vue